import { useCouponRules } from '../couponRulesContext';
import { CheckInput } from '../../checkInput'
import { InputDiv } from '../inputDiv'

import { DoubleInput } from './style';



export function ContainerDoubleInput() {
    const { 
            inputMinValueChecked, setInputMinValueChecked, 
            setInputMinValueText,
            inputMaxQuantityChecked, setInputMaxQuantityChecked,
            setInputMaxQuantityText
    } = useCouponRules()

    return(
        <>
            <DoubleInput>
                <CheckInput 
                    handleClickCheck={setInputMinValueChecked}
                    inputValueToChange={inputMinValueChecked}
                />
                <InputDiv 
                    inputActive={inputMinValueChecked}
                    setInputText={setInputMinValueText}
                    type="minValue"
                    title="Valor mínimo"
                    explain="(referente a soma total dos produtos)"
                    placeholder="R$ 0,00"
                />
            </DoubleInput>


            <DoubleInput>
                <CheckInput 
                    handleClickCheck={setInputMaxQuantityChecked}
                    inputValueToChange={inputMaxQuantityChecked}
                />
                <InputDiv 
                    inputActive={inputMaxQuantityChecked}
                    setInputText={setInputMaxQuantityText}
                    type="maxQuantity"
                    title="Quantidade máxima"
                    explain="(referente a quantidade de cupons disponíveis)"
                    placeholder="0"
                />
            </DoubleInput>
        </>
    )
}
